import { render, staticRenderFns } from "./view-switch-section.vue?vue&type=template&id=748a4a2a&"
import script from "./view-switch-section.vue?vue&type=script&lang=js&"
export * from "./view-switch-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports